import profile from './profile';
import campaigns from './campaigns';

const index = {
  profile,
  campaigns,
};

export default index;